import env from '~/libs/env'

function getHostName(url) {
  let hostname
  try {
    let newUrl = new URL(url)
    hostname = newUrl.hostname
  } catch (err) {}
  return hostname
}

function addSafeUrl(safeUrls = [], url) {
  let hostName = getHostName(url)
  if (hostName) {
    return [...safeUrls, hostName]
  }
  return safeUrls
}

export function getSafeUrls () {
  let safeUrls = [
    'lp.lendio.com',
    'www.lendio.com',
    'docs.lendio.com',
  ]

  safeUrls = addSafeUrl(safeUrls, env('bpBaseUrl'))
  safeUrls = addSafeUrl(safeUrls, env('baseUrl'))
  safeUrls = addSafeUrl(safeUrls, env('oktaBaseUrl'))

  return safeUrls
}

export function checkUrlSafety(url) {
  if (!url) {
    return false
  }

  if (typeof url !== 'string') {
    return false
  }

  if (url.length == 0) {
    return false
  }

  let isSafe = false
  try {
    let newUrl = new URL(url)
    const hostname = newUrl.hostname
    isSafe = getSafeUrls().some(safeUrl => hostname.startsWith(safeUrl))
  } catch (err) {}

  return isSafe
}

export function safeRedirect ({ router, redirectUrl }) {
  if (router && router.history && router.history.current && router.history.current.path == '/attempted-redirect') {
    return // Attempt to prevent infinite redirects
  }
  if (process.client && window && window.location.href.includes('/attempted-redirect')) {
    return // Attempt to prevent infinite redirects
  }

  if (!redirectUrl) {
    log.warning('external-redirects: redirectUrl does not exist. Make sure you\'re passing it in as a context object. e.g. { redirectUrl: \'https://google.com\' }')
    return
  }
  if (typeof redirectUrl !== 'string') {
    log.warning('external-redirects: redirectUrl must be a string', { redirectUrl })
    return
  }
  if (router && typeof router.push !== 'function') {
    log.warning('external-redirects: router missing the push function')
    return
  }



  const urlIsSafe = checkUrlSafety(redirectUrl)
  if (!urlIsSafe) {
    console.warn('external-redirects: url is not included in our list of safe urls', { redirectUrl })
  }

  if (process.server) {
    if (!router) {
      log.error('external-redirects: Cannot redirect on the server without the router')
      return
    }

    router.push({ path: '/redirect-from-lendio', query: { external_url: redirectUrl }})
  }

  if (process.client && !urlIsSafe) {
    if (!router) {
      log.error('external-redirects: Cannot redirect to an unsafe url without the router')
      return
    }
    router.push(`/attempted-redirect?external_url=${redirectUrl}`)
    return
  }

  if (process.client && typeof window !== 'undefined' && urlIsSafe) {
    window.location = redirectUrl
  }
}

export default {
  getSafeUrls,
  checkUrlSafety,
  safeRedirect,
}
